import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdatePredictionFeedback = ClientInferResponseBody<
  typeof contract.feedback.updatePredictionFeedback
>;

export type UpdatePredictionFeedbackDto = ClientInferRequest<
  typeof contract.feedback.updatePredictionFeedback
>["body"];

export const updatePredictionFeedback = async ({
  feedbackId,
  payload,
}: {
  feedbackId: string | undefined;
  payload: UpdatePredictionFeedbackDto;
}): Promise<UpdatePredictionFeedback> => {
  if (!feedbackId) {
    throw new Error("Feedback ID is required");
  }

  const response = await api.feedback.updatePredictionFeedback.mutation({
    params: {
      feedbackId,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update PredictionFeedback", response.status, response.body);
};
